import type { CSSProperties } from "react";

export const FIRST_LAND_PREF_KEY = "firstLandModalState";
//[COPIED] QuizSplitUseCaseGroup Must be same as account texts without i18n
export enum QuizSplitUseCaseGroup {
    ANALYZE_WEBSITES = "Analyze websites and market trends",
    IMPROVE_SEO = "Improve Organic and Paid Channels",
    GEN_AI = "Improve brand visibility on LLM",
}

export const MODAL_STYLES: CSSProperties = {
    width: "550px",
    height: "auto",
};

export const ROCKET_GIF = "/images/activation/gif/rocket.gif";

export const ANALYZE_WEBSITES_IMAGE = "/images/firstLandModal/analyze_website.jpg";
export const IMPROVE_SEO_IMAGE = "/images/firstLandModal/improve_seo.jpg";
export const GEN_AI_IMAGE = "/images/firstLandModal/gen_ai.jpg";
